import { AddAlertOutlined } from '@mui/icons-material';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { NeedsAttentionCard } from '@/views/Home/components/NeedsAttention/components/NeedsAttentionCard';
import {
  TrackHomePageEvent,
  useTrackHomePageAnalytics,
} from '$analytics/useTrackAnalytics/domains/homePage';
import type { CoreRequest } from '$api-clients/hooks';
import { ListingAgreementInteractionModal } from './ListingAgreementInteractionModal';

export function ListingAgreementsExpiringSoon({
  interactionCount,
  interactions,
}: {
  interactionCount: number;
  interactions: CoreRequest<'/listings'>['Data']['results'];
}) {
  const trackEvent = useTrackHomePageAnalytics();
  const router = useRouter();
  const [modalOpen, setModalOpen] = useState(false);

  const supplementaryDetails: string[] = ['Listing end date is within a week'];

  const handleClick = () => {
    trackEvent(TrackHomePageEvent.NeedsAttentionCardClick, {
      numItem: interactionCount,
      eventTarget: 'listing_agreement',
    });

    if (interactionCount > 1) {
      setModalOpen(true);
    } else {
      const { id = '' } = interactions.at(0) ?? {};

      void router.push(
        `/listings/${id}/cover-sheet?utm_source=hp&utm_medium=nac`,
      );
    }
  };

  useEffect(() => {
    if (!interactionCount) return;

    trackEvent(TrackHomePageEvent.NeedsAttentionCardMount, {
      numItem: interactionCount,
      eventTarget: 'listing_agreement',
    });
  });

  return (
    <>
      <ListingAgreementInteractionModal
        numItems={interactionCount}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      />
      <NeedsAttentionCard
        itemCount={interactionCount}
        color="warning"
        headerStartAdornment={<AddAlertOutlined />}
        onClick={handleClick}
        supplementaryDetails={supplementaryDetails}
        title="Listing Agreements Expiring Soon"
      />
    </>
  );
}

ListingAgreementsExpiringSoon.displayName = 'ListingAgreementsExpiringSoon';
